<template>
  <b-row class="justify-content-center">
    <b-col
      cols="12"
      sm="11"
      md="11"
      lg="10"
    >
      <b-container>
        <ThePickAthletes
          :selected-athletes="selectedAthletes"
          :round-id="round.id"
          @onPlayerAdd="handleScrollToAddPlayer"
          @onAthletePickRemove="(params) => $emit('onAthletePickRemove', params)"
        />
      </b-container>
    </b-col>

    <b-col :cols="12">
      <AddPlayer
        :round="round"
        :is-athlete-assignment-processing="isAthleteAssignmentProcessing"
        :selected-athletes="selectedAthletes"
        @onAthletePick="(params) => $emit('onAthletePick', params)"
        @onAthletePickRemove="(params) => $emit('onAthletePickRemove', params)"
      />
    </b-col>
  </b-row>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import ThePickAthletes from '@/pages/RoundDetail/Components/Molecules/ThePickAthletes'
import AddPlayer from '@/pages/RoundDetail/Routes/MyTeam/AddPlayer/AddPlayer'

export default {
  name: 'MyTeamUpcoming',
  components: {
    AddPlayer,
    ThePickAthletes,
  },
  props: {
    round: {
      type: Object,
      required: true,
    },
    selectedAthletes: {
      type: Array,
      required: true,
      default: () => [],
    },
    isAthleteAssignmentProcessing: {
      type: Number,
      required: false,
      default: null,
    },
  },
  methods: {
    handleScrollToAddPlayer() {
      VueScrollTo.scrollTo('#addPlayer', 500, {
        container: 'body',
      })
    },
  },
}
</script>
